import { parseRawBoolean } from '@data/api/helpers';
import Image from './Image';
import MultilangText from './MultilangText';
class Addon {
    constructor(data) {
        var _a, _b, _c;
        Object.defineProperty(this, "accommodationBookedId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "adults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "available", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bookedId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "chargeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentStock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "doNotTrack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "feesArray", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "feesGroupedById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "grandTotal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "images", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFixedRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxQtyPerReservation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "order", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "postingStrategy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pricingBreakdown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rateWithInclusive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "roomId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "roomRateid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stopSelling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taxesArray", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taxesGroupedById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalFees", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalRateWithInclusive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalTaxes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weekAvailability", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data) {
            return;
        }
        this.id = data.addonId.toString();
        this.productId = data.productId.toString();
        this.roomId = data.roomId;
        this.packageId = data.packageId.toString();
        this.name = new MultilangText(data.addonName);
        this.images = data.addonPhotos.map((addonPhoto) => new Image(addonPhoto));
        this.description = new MultilangText(data.addonDescription);
        this.chargeType = (((_a = data.chargeType) === null || _a === void 0 ? void 0 : _a.replaceAll('_', '-')) ||
            'per-reservation');
        this.weekAvailability = data.weekAvailability;
        this.maxQtyPerReservation = data.maxQtyPerReservation || 0;
        this.available = data.available;
        this.isFixedRate = parseRawBoolean(data.isFixedPrice);
        this.quantity = data.qty;
        this.rate = data.price;
        this.rateWithInclusive = data.priceWithInclusive;
        this.totalRate = data.totalPrice;
        this.totalRateWithInclusive = data.totalPriceWithInclusive;
        this.totalTaxes = data.totalTaxes;
        this.totalFees = data.totalFees;
        this.grandTotal = data.grandTotal;
        this.taxesGroupedById = data.taxesGroupedById;
        this.feesGroupedById = data.feesGroupedById;
        this.taxesArray = data.taxesArray;
        this.feesArray = data.feesArray;
        this.dailyRates = data.dailyRates;
        this.priceSettings = data.priceSettings;
        this.postingStrategy = data.postingStrategy;
        if (data.pricingBreakdown &&
            data.pricingBreakdown.chargeTypeDetails &&
            data.pricingBreakdown.chargeTypeDetails.type) {
            this.pricingBreakdown = data.pricingBreakdown;
            this.pricingBreakdown.calculationMethod =
                (((_b = data.pricingBreakdown.calculationMethod) === null || _b === void 0 ? void 0 : _b.replaceAll('_', '-')) ||
                    'per-reservation');
            this.pricingBreakdown.chargeTypeDetails.type =
                (((_c = data.pricingBreakdown.chargeTypeDetails.type) === null || _c === void 0 ? void 0 : _c.replaceAll('_', '-')) ||
                    'per-reservation');
        }
        this.currentStock = data.currentStock;
        this.doNotTrack = parseRawBoolean(data.doNotTrack);
        this.stopSelling = data.stopSelling;
        this.productType = data.productType;
        this.adults = data.adults;
        this.kids = data.kids;
        this.order = Number.isNaN(data.order) ? -1 : Number(data.order);
    }
}
Object.defineProperty(Addon, "matchesItem", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (a, b) => a.roomId === b.roomId &&
        a.packageId === b.packageId &&
        a.adults === b.adults &&
        a.kids === b.kids
});
export default Addon;
